import axios from 'axios';
import store from "../components/reduxStore/store";

export default axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 120 * 1000,
    responseType: "json",
    headers: {'Authorization': "Bearer " + [store.getState().applicant_key]}
});